import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { PropertiesPanelPopoverContent } from "../../panels/PropertiesPanelPopoverContent";
import { Popover as UiPopover } from "../../popup/Popover";
import { zIndexes } from "../../utilities/zIndexes";

const Popover = styled(UiPopover)`
  z-index: ${zIndexes.propertiesPanelPopover};

  .MuiPaper-root {
    overflow: visible;
    border-radius: 8px;
  }
`;

interface Props {
  open: boolean;
  anchorEl: HTMLDivElement | null;
  header?: ReactNode;
  settingsForm?: ReactNode;
  onClose: () => void;
  renderPreview: () => ReactNode;
}

export const MediaAssetPopover = ({ open, anchorEl, header, onClose, settingsForm, renderPreview }: Props) => (
  <Popover
    id={`media-asset-popover`}
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "center", horizontal: "left" }}
    transformOrigin={{ vertical: "center", horizontal: 270 }}
  >
    <PropertiesPanelPopoverContent onClose={onClose} header={header}>
      {renderPreview()}
      {settingsForm}
    </PropertiesPanelPopoverContent>
  </Popover>
);
